import { ProductInterface } from '@pylot-data/fwrdschema'
import { ProductPrice } from '@components/common/ProductPrice/ProductPrice'
import Link from '@corratech/pylot-ui/src/Link'
import s from '@components/MultiBuyProducts/MultiBuyProducts.module.scss'
import cn from 'classnames'
import Image from '@corratech/pylot-image'
import { ReadMore } from '@components/Readmore/ReadMore'
import { useTranslation } from 'next-i18next'
import { getPDPUrl } from '@lib/getPDPUrl'

type MultiBuyProductCardProps = {
    onClick: () => void
    product: ProductInterface
    selected: boolean
    isDefault?: boolean
    isMobile: boolean
    isPdpProduct?: boolean
}

export const MultiBuyProductCard = ({
    product,
    onClick,
    selected,
    isDefault,
    isMobile,
    isPdpProduct
}: MultiBuyProductCardProps) => {
    const { url_key } = product
    const productUrl = getPDPUrl(url_key!)
    const { t } = useTranslation('common')

    return (
        <div className={cn(s['multi-buy-productcard'])}>
            <div
                className={cn(s['product-details'], s['productitem-block'], {
                    pdp_product_div: isPdpProduct
                })}
            >
                <div className={cn(s['product-description'])}>
                    <div className={cn(s['productimage-block'])}>
                        {!isPdpProduct && (
                            <div
                                onClick={() => onClick()}
                                role="button"
                                aria-hidden="true"
                                className={cn(s['checkbox-wrapper'])}
                            >
                                <input
                                    type="checkbox"
                                    name="toggle"
                                    id={`toggle-${product.sku}`}
                                    className="form-checkbox"
                                    checked={selected}
                                />
                            </div>
                        )}
                        <div
                            className={cn(
                                s['productimg-link'],
                                'product-card-image-swipe',
                                'slider-product-img'
                            )}
                        >
                            <div
                                className={cn(
                                    s['productitem-image'],
                                    s['multibuy-col']
                                )}
                            >
                                <Link href={productUrl}>
                                    <Image
                                        src={product?.thumbnail?.url || ''}
                                        alt={
                                            product.name
                                                ? product.name
                                                : 'placeholder'
                                        }
                                        width={390}
                                        height={390}
                                        className={s['product-img']}
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className={s['product-name-price']}>
                        <h2
                            className={cn(s['product-name'])}
                            title={product.name || ''}
                        >
                            <Link href={productUrl}> {product.name}</Link>
                        </h2>
                    </div>
                    {isDefault && (
                        <span className={s['default-item']}>
                            {t('This item')}
                        </span>
                    )}
                    <ReadMore
                        className={s['read-more']}
                        content={product.short_description?.html || ''}
                    />
                    <div className={cn(s['product-price-col'])}>
                        <ProductPrice
                            priceRange={product.price_range}
                            is_bulk_product={!!product.is_bulk_product}
                            showDiscountPrice={!product?.is_bulk_product}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
